// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.proofOfIncome.landing.';

const CONTINUE_PROOF_INCOME_METHOD_BUTTON = `${DOMAIN}continueButton`;

export { CONTINUE_PROOF_INCOME_METHOD_BUTTON };
